/**
 * Phase 3 - Italian translations module
 */
import enBase from './en.js';
import { translationsIt } from '../../utils/translations/translations.it.js';
import { plansTranslationsIt } from '../../utils/translations/plans/plansTranslations.it.js';

const merged = { ...enBase, ...translationsIt, ...plansTranslationsIt };
export default merged;
